import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import ArticleCategory from "../../../entities/productOrder/article/ArticleCategory";
import { ArticleCategoryService } from "../../../service/articleDelivery/ArticleCategoryService";


class RemoveArticleCategoryStore {

    public articleCategory: ArticleCategory;
    public loading: boolean;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore, articleCategory: ArticleCategory) {
        this.articleCategory = articleCategory;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }


    @action
    public async remove() {
        const response = await ArticleCategoryService.remove(this.articleCategory);
        this.commonStore.processErrors(response);
        return response.success;
    }
}

export default RemoveArticleCategoryStore;

